import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#FDFBF7] border-t border-gray-200 py-12 px-4" data-id="element-30">
        <div className="max-w-4xl mx-auto text-center" data-id="element-31">
          <p className="text-gray-500 text-sm mb-6" data-id="element-32">
            Este producto es educativo. No sustituye consejo médico profesional.
            Consulta siempre a tu médico antes de realizar cambios en tu dieta o
            tratamiento.
          </p>

          <div className="flex justify-center gap-6 text-sm text-gray-600" data-id="element-33">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#C05621] transition-colors underline decoration-dotted" data-id="element-34">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#C05621] transition-colors underline decoration-dotted" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>

          <p className="mt-8 text-xs text-gray-400" data-id="element-36">
            © {new Date().getFullYear()} El Plato Mexicano Antipicos. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-37">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-38">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" data-id="element-39">
              <div className="p-4 border-b border-gray-100 flex justify-between items-center bg-[#FDFBF7]" data-id="element-40">
                <h3 className="font-bold text-gray-800" data-id="element-41">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-42">
                  <X className="w-5 h-5 text-gray-500" data-id="element-43" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto text-sm text-gray-600 space-y-4" data-id="element-44">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-45">
                      <strong data-id="element-46">1. Recopilación de Información:</strong>{' '}
                      Recopilamos información personal que usted nos proporciona
                      voluntariamente al realizar una compra, como su nombre y
                      dirección de correo electrónico.
                    </p>
                    <p data-id="element-47">
                      <strong data-id="element-48">2. Uso de la Información:</strong> Utilizamos su
                      información para procesar su pedido, entregar el producto
                      digital y enviarle actualizaciones relevantes.
                    </p>
                    <p data-id="element-49">
                      <strong data-id="element-50">3. Protección de Datos:</strong> Implementamos
                      medidas de seguridad para proteger su información
                      personal. No vendemos ni compartimos sus datos con
                      terceros no afiliados.
                    </p>
                    <p data-id="element-51">
                      <strong data-id="element-52">4. Cookies:</strong> Utilizamos cookies y
                      tecnologías similares (como el Píxel de Meta) para mejorar
                      su experiencia y analizar el tráfico del sitio.
                    </p>
                    <p data-id="element-53">
                      <strong data-id="element-54">5. Sus Derechos:</strong> Usted tiene derecho a
                      acceder, corregir o eliminar su información personal en
                      cualquier momento contactándonos.
                    </p>
                  </> : <>
                    <p data-id="element-55">
                      <strong data-id="element-56">1. Aceptación:</strong> Al comprar este producto,
                      usted acepta estos términos y condiciones en su totalidad.
                    </p>
                    <p data-id="element-57">
                      <strong data-id="element-58">2. Uso Personal:</strong> El producto "El Plato
                      Mexicano Antipicos" es para uso personal y no comercial.
                      Está prohibida su distribución o reventa.
                    </p>
                    <p data-id="element-59">
                      <strong data-id="element-60">3. Descargo de Responsabilidad Médica:</strong>{' '}
                      Este producto es puramente educativo e informativo. No
                      constituye consejo médico. El autor no es médico. Consulte
                      a su profesional de la salud antes de realizar cambios en
                      su dieta.
                    </p>
                    <p data-id="element-61">
                      <strong data-id="element-62">4. Garantía:</strong> Ofrecemos una garantía de
                      devolución de dinero de 7 días. Si no está satisfecho,
                      contáctenos dentro de este período para un reembolso
                      completo.
                    </p>
                    <p data-id="element-63">
                      <strong data-id="element-64">5. Propiedad Intelectual:</strong> Todo el
                      contenido, diseño y material están protegidos por derechos
                      de autor.
                    </p>
                  </>}
              </div>

              <div className="p-4 border-t border-gray-100 bg-gray-50 text-right" data-id="element-65">
                <button onClick={() => setActiveModal(null)} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md font-medium transition-colors" data-id="element-66">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}